import React from 'react'

import { QuotesIcon } from '../assets/icons'
import { testimonials } from '../data/college.data'

const TestimonialsSection = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-screen-2xl lg:px-8 space-y-16 py-12 w-full">
      <h3
        className="text-left text-3xl md:text-4xl font-semibold tracking-tight"
        style={{
          textDecoration: 'underline',
          textDecorationColor: '#FDBA74',
          textDecorationThickness: '10px',
          textDecorationSkipInk: 'none',
          textUnderlineOffset: '-40%',
          textUnderlinePosition: 'under'
        }}>
        Devsnest Alumni Says,
      </h3>

      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {testimonials.map((testimonial) => (
          <div
            key={testimonial.name}
            className="px-6 py-4 shadow-md rounded-md bg-white relative">
            <QuotesIcon className="h-10 w-10 text-red-100 absolute top-4 left-6" />

            <div className="flex flex-col justify-between h-full pt-12">
              <p className="text-zinc-500 text-base md:text-lg font-medium">
                {testimonial.text}
              </p>

              <div className="border-t border-zinc-200 flex items-start pt-4 mt-4">
                <div className="flex-shrink-0 inline-flex rounded-full border-2 border-white">
                  <img
                    className="h-12 w-12 rounded-full"
                    src={testimonial.avatar}
                    alt=""
                  />
                </div>
                <div className="ml-4">
                  <div className="text-base font-medium text-zinc-600">
                    {testimonial.name}
                  </div>
                  <div className="text-base font-medium text-stone-400">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TestimonialsSection
